"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = exports.unFormatCurrency = exports.getCurrencyOptions = exports.unAppendCurrency = exports.appendCurrency = exports.negativePriceValue = exports.fixPriceValue = exports.formatMoneyValue = exports.formatCurrency = void 0;
const currency_formatter_1 = require("currency-formatter");
const locale_currency_1 = require("locale-currency");
const currencies_1 = require("./currencies");
/**
 * Format a number to currency representation
 * eg: formatCurrency(1000, 'USD') = $1,000.00
 * @param value Number to be formatted
 * @param countryCode 2 letter country code or 3 letter currency code
 */
function formatCurrency(value, code) {
    if (typeof value !== 'number' || typeof code !== 'string') {
        throw new Error('Expected two arguments of type number, string');
    }
    if (code.length === 2) {
        return (0, currency_formatter_1.format)(value, { locale: code });
    }
    else {
        return (0, currency_formatter_1.format)(value, { code: code });
    }
}
exports.formatCurrency = formatCurrency;
/**
 * Format a number to locale currency representation without symbol
 * eg: formatCurrency(1000, 'USD') = 1,000.00
 * @param value Number to be formatted
 * @param countryCode 2 letter country code or 3 letter currency code
 */
function formatMoneyValue(value, code) {
    if (typeof value !== 'number' || typeof code !== 'string') {
        throw new Error('Expected two arguments of type number, string');
    }
    if (code.length === 2) {
        return (0, currency_formatter_1.format)(value, { locale: code, format: '%v' });
    }
    else {
        return (0, currency_formatter_1.format)(value, { code: code, format: '%v' });
    }
}
exports.formatMoneyValue = formatMoneyValue;
/**
 *
 * @param value value may contain any letters
 * @returns price which contains 9 digits and 2 decimals
 */
const fixPriceValue = (value) => {
    let result = (value || '').replace(/[^0-9]./g, '');
    const dotIndex = (value || '').indexOf('.');
    if (dotIndex >= 0) {
        const numbersBeforeDot = value.substr(0, dotIndex);
        const decimals = value.substr(dotIndex, 3).replace(/\./g, '');
        result = numbersBeforeDot.substr(0, 9) + '.' + decimals;
    }
    else {
        result = result.substr(0, 9);
    }
    return result;
};
exports.fixPriceValue = fixPriceValue;
/**
 *
 * @param value value may contain any letters
 * @returns price which contains 2 decimals and allow negative value
 */
const negativePriceValue = (value) => {
    let sanitized = (value || '').replace(/[a-zA-Z]/g, '');
    const match = sanitized.match(/^-?\$?\d*\.?\d{0,2}/);
    return match ? match[0] : '';
};
exports.negativePriceValue = negativePriceValue;
/**
 * Format a number to currency representation
 * eg: formatCurrency('1000', 'USD') = $1000
 * eg: formatCurrency('-1000', 'USD') = -$1000
 * @param value string to be formatted
 * @param countryCode 2 letter country code or 3 letter currency code
 */
function appendCurrency(value, code) {
    var _a;
    if (typeof value !== 'string' || typeof code !== 'string') {
        throw new Error('Expected two arguments of type string, string');
    }
    const symbol = (_a = (0, currency_formatter_1.findCurrency)(code.length === 2 ? (0, locale_currency_1.getCurrency)(code) : code)) === null || _a === void 0 ? void 0 : _a.symbol;
    if (parseFloat(value) < 0) {
        const absValue = value.replace('-', '');
        return symbol && value
            ? '-' + symbol + (0, exports.fixPriceValue)(absValue)
            : '-' + (0, exports.fixPriceValue)(absValue) + '';
    }
    return symbol && value
        ? symbol + (0, exports.fixPriceValue)(value)
        : (0, exports.fixPriceValue)(value) + '';
}
exports.appendCurrency = appendCurrency;
/**
 * Format a number to currency representation
 * eg: formatCurrency('$100.21', 'USD') = 100.21
 * @param value string to be formatted
 * @param countryCode 2 letter country code or 3 letter currency code
 */
function unAppendCurrency(value, code) {
    var _a;
    if (typeof value !== 'string' || typeof code !== 'string') {
        throw new Error('Expected two arguments of type string, string');
    }
    const symbol = (_a = (0, currency_formatter_1.findCurrency)(code.length === 2 ? (0, locale_currency_1.getCurrency)(code) : code)) === null || _a === void 0 ? void 0 : _a.symbol;
    if (symbol && value.includes(symbol) && !value.includes('-')) {
        return (0, exports.fixPriceValue)(value.substring(1));
    }
    if (symbol && value.includes(symbol) && value.includes('-')) {
        return '-' + (0, exports.fixPriceValue)(value.substring(2));
    }
    else {
        if (value.startsWith('-')) {
            return (0, exports.negativePriceValue)(value);
        }
        else {
            return (0, exports.fixPriceValue)(value);
        }
    }
}
exports.unAppendCurrency = unAppendCurrency;
/**
 * Get an array of currency denominations of a country
 * eg: getCurrencyOptions('AU') = ['100', '50', '20', '10', '5', '2', '1', '0.5', '0.2', '0.1', '0.05']
 * @param 2 letter country code
 */
function getCurrencyOptions(countryCode) {
    if (typeof countryCode !== 'string') {
        throw new Error('Expected country code to be of type string');
    }
    if (countryCode.length !== 2) {
        throw new Error('Expected 2 letter country code');
    }
    if (!currencies_1.currencyOptions[countryCode.toUpperCase()]) {
        return [];
    }
    return currencies_1.currencyOptions[countryCode.toUpperCase()];
}
exports.getCurrencyOptions = getCurrencyOptions;
/**
 * Un format a number to currency representation
 * eg: unFormatCurrency($1,000.00, 'USD') = 1000
 * @param value Number to be formatted
 * @param countryCode 2 letter country code or 3 letter currency code
 */
function unFormatCurrency(value, code) {
    if (typeof value !== 'string' || typeof code !== 'string') {
        throw new Error('Expected two arguments of type string, string');
    }
    if (code.length === 2) {
        return (0, currency_formatter_1.unformat)(value, { locale: code });
    }
    else {
        return (0, currency_formatter_1.unformat)(value, { code: code });
    }
}
exports.unFormatCurrency = unFormatCurrency;
function getCurrencySymbol(currencyCode, defaultCurrency = '$') {
    var _a;
    if (!currencyCode)
        return defaultCurrency;
    return (_a = (0, currency_formatter_1.findCurrency)(currencyCode)) === null || _a === void 0 ? void 0 : _a.symbol;
}
exports.getCurrencySymbol = getCurrencySymbol;
//# sourceMappingURL=currency.js.map